import React, { useState, useMemo } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Divider,
  CircularProgress,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

import { AppContext } from "context";
import { ReactComponent as TXOneLogo } from "assets/images/logo_txone.svg";
import { Sidebar } from "./Sidebar/Sidebar";
import { useFetch } from "hooks";
import { useLogout } from "./hooks";
import {
  // getRoleId,
  getTXOneAccountUrl,
} from "utils";

export const AdminLayout = () => {
  const navigate = useNavigate();
  const [userIconEl, setUserIconEl] = useState(null);
  const theme = useTheme();
  const logout = useLogout();
  const { isLoading, data: userInfo } = useFetch("/api/v1/user", "get");
  const txoneAccountUrl = getTXOneAccountUrl();
  const changePwdUrl = `${txoneAccountUrl}/change_pwd`;
  const appCtx = useMemo(() => {
    return {
      userInfo,
    };
  }, [userInfo]);

  if (isLoading || !userInfo) {
    return <CircularProgress />;
  }

  return (
    <AppContext.Provider value={appCtx}>
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexFlow: "column",
        }}
      >
        <AppBar
          sx={{
            zIndex: theme.zIndex.drawer + 1,
            backgroundColor: theme.palette.primary.main,
          }}
          elevation={0}
        >
          <Toolbar
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              paddingTop: theme.spacing(2),
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  width: 150,
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
                onClick={() => navigate("/overview")}
              >
                <TXOneLogo />
              </Box>
              <Divider
                orientation="vertical"
                sx={{
                  backgroundColor: "#FFFFFF",
                  width: "1px",
                  height: "40px",
                  opacity: 0.6,
                  marginRight: theme.spacing(2),
                  marginLeft: theme.spacing(2),
                }}
              />
              <Typography
                variant="h5"
                component="div"
                noWrap
                color="inherit"
                sx={{
                  userSelect: "none",
                  fontSize: 20,
                }}
              >
                myTXOne
              </Typography>
            </Box>
            <Box>
              <IconButton
                color="inherit"
                onClick={(e) => {
                  setUserIconEl(e.target);
                }}
              >
                <AccountCircleIcon />
              </IconButton>
            </Box>
            <Menu
              anchorEl={userIconEl}
              keepMounted
              open={Boolean(userIconEl)}
              onClose={() => setUserIconEl(null)}
            >
              <MenuItem
                component="a"
                href={changePwdUrl}
                target="_blank"
                onClick={() => {
                  setUserIconEl(null);
                }}
              >
                Change Password
              </MenuItem>
              <Divider />
              <MenuItem onClick={logout}>Logout</MenuItem>
            </Menu>
          </Toolbar>
        </AppBar>
        <Box
          sx={{
            display: "flex",
            flexGrow: 1,
          }}
        >
          <Sidebar />
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              height: "100vh",
              backgroundColor: "#F2F2F2",
              padding: theme.spacing(3),
              overflow: "auto",
            }}
          >
            <Toolbar />
            <Outlet context={{ userInfo }} />
          </Box>
        </Box>
      </Box>
    </AppContext.Provider>
  );
};
export default AdminLayout;
